import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { Observable, empty } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { IAttributeOption, IBuildPakAttribute, IProductAttribute, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class V6attributeService {

  constructor(private httpClient: HttpClient) { }


  //#region Hard Coded Data
  private attributeList: any[] = [

    {
      name: "Transom", publishedName: 'Transom', type: "radio", show: true, value: '', options: [
        { code: 'Non-Transom', value: '', description: 'Non-Transom', show: true, },
        { code: 'Transom', value: 'TR', description: 'Transom', show: true, }
      ]
    },
    {
      name: "STD_DR_Multi DO Frame systems", publishedName: 'Frame System', show: true, value: '', type: "list", options: [
        { code: '01', value: 'TF', description: 'Trifab 400', show: true },
        { code: '11', value: 'TF', description: 'Trifab VG 450', show: true },
        { code: '12', value: 'TF', description: 'Trifab VG 451', show: true },
        { code: '13', value: 'TF', description: 'Trifab VG 451T', show: true },
        { code: '16F', value: 'TF', description: 'Trifab 601 (Tubular W/Fin)', show: true },
        { code: '16', value: 'TF', description: 'Trifab 601', show: true },
        { code: '17', value: 'TF', description: 'Trifab 601T', show: true },
        { code: '05P', value: 'ENC', description: 'Encore 4 1/2" - 1 Piece Jambs', show: true },
        { code: '05PP', value: 'ENC', description: 'Encore 4 1/2" - 2 Piece Jambs', show: true },
        { code: '06PP', value: 'ENC', description: 'Encore 6" - 2 Piece Jambs', show: true },
      ]
    },
    {
      name: "KK Frame systems", publishedName: 'Frame System', show: true, value: '', type: "list", options: [
        { code: '01', value: 'TF', description: 'Trifab 400', show: true },
        { code: '11', value: 'TF', description: 'Trifab VG 450', show: true },
        { code: '12', value: 'TF', description: 'Trifab VG 451', show: true },
        { code: '13', value: 'TF', description: 'Trifab VG 451T', show: true },
        { code: '16F', value: 'TF', description: 'Trifab 601 (Tubular W/Fin)', show: true },
        { code: '16', value: 'TF', description: 'Trifab 601', show: true },
        { code: '17', value: 'TF', description: 'Trifab 601T', show: true },
        { code: '05P', value: 'ENC', description: 'Encore 4 1/2" - 1 Piece Jambs', show: true },
        { code: '05PP', value: 'ENC', description: 'Encore 4 1/2" - 2 Piece Jambs', show: true },
        { code: '06PP', value: 'ENC', description: 'Encore 6" - 2 Piece Jambs', show: true },
      ]
    },
    {
      name: "STD_DR_1DO TF Frame system", publishedName: 'Frame System', show: true, value: '', type: "list", options: [
        { code: '00', value: 'DO36', description: 'Door Only No Framing', show: true },
        { code: '01', value: 'TF', description: 'Trifab 400', show: true },
        { code: '11', value: 'TF', description: 'Trifab VG 450', show: true },
        { code: '12', value: 'TF', description: 'Trifab VG 451', show: true },
        //{ code: '13', value: 'TF', description: 'Trifab VG 451T', show: true },
        //{ code: '16F', value: 'TF', description: 'Trifab 601 (Tubular W/Fin)', show: true },
        //{ code: '16', value: 'TF', description: 'Trifab 601', show: true },
        //{ code: '17', value: 'TF', description: 'Trifab 601T', show: true },
        //{ code: '05P', value: 'ENC', description: 'Encore 4 1/2" - 1 Piece Jambs', show: true },
        //{ code: '05PP', value: 'ENC', description: 'Encore 4 1/2" - 2 Piece Jambs', show: true },
        //{ code: '06PP', value: 'ENC', description: 'Encore 6" - 2 Piece Jambs', show: true },
      ]
    },
    {
      name: "STD_DR DR Type", publishedName: 'Door Type', show: true, value: '', type: "list", options: [
        { code: '01', value: '', description: '190 Narrow Stile', show: true },
        { code: '02', value: '', description: '350 Medium Stile', show: true },
        { code: '03', value: '', description: '500 Wide Stile', show: true },
        { code: '01BPES', value: '', description: 'Outer Frame Only - Single Door Opening', show: true },
        { code: '01BPEP', value: '', description: 'Outer Frame Only - Pair Door Opening', show: true },
      ]
    },
    {
      name: "KK DR Series", publishedName: 'Door Series', show: true, value: '', type: "list", options: [
        { code: '01', value: '', description: '190 Narrow Stile', show: true },
        { code: '02', value: '', description: '350 Medium Stile', show: true },
        { code: '03', value: '', description: '500 Wide Stile', show: true },
        { code: '01BPES', value: '', description: 'Outer Frame Only - Single Door Opening', show: true },
        { code: '01BPEP', value: '', description: 'Outer Frame Only - Pair Door Opening', show: true },
      ]
    },
    {
      name: "Handing", publishedName: 'Handing', show: true, value: '', type: "list", options: [
        { code: '01', value: 'S', description: 'S/A LHOS (H/R OUT-SWING)', show: true },
        { code: '03', value: 'S', description: 'S/A RHOS (H/L OUT-SWING)', show: true },
        { code: '05', value: 'S', description: 'D/A LHOS (H/R D/A)', show: true },
        { code: '06', value: 'S', description: 'D/A RHOS (H/L D/A)', show: true },
        { code: '07', value: 'P', description: 'S/A PAIR', show: true },
        { code: '09', value: 'P', description: 'D/A PAIR', show: true },
      ]
    },
    {
      name: "STD_DR Hinging", publishedName: 'Hinging', show: true, value: '', type: "list", options: [
        { code: '01', value: 'BV', description: 'Standard Offset Pivots', show: true },
        { code: '16', value: 'BV', description: 'Standard 304 SS NRP Butts', show: true },
        { code: '05', value: 'BV', description: 'Standard Continuous Hinge', show: true },
        { code: '07', value: 'RD', description: 'C.O.C.  End Load', show: true },
        { code: '14', value: 'RD', description: 'C.O.C. Side Load', show: true },
        { code: '12', value: 'BV', description: 'Standard Top/Bottom Offset Pivot (M19 Int)', show: true },
        { code: '04C', value: 'BV', description: 'US32D SS Butts', show: true },
        { code: '08', value: 'RD', description: 'C/H Bottom Pivot / Top Walking Beam Pivot', show: true },
        { code: '00', value: 'BV', description: 'None (Beveled Stiles)', show: true },
        { code: '86', value: 'BV', description: 'None (Rabbeted Hinge Stiles)', show: true },
        { code: '00R', value: 'RD', description: 'None (Radius Stile)', show: true },
        { code: '06', value: 'RD', description: 'Top Walking Beam Pivot / No prep at Bottom', show: true },
        { code: '10', value: 'BV', description: 'Standard Top Offset Pivot (No Bottom)', show: true },
        { code: '11', value: 'BV', description: 'Standard Bottom Offset Pivot (M19 Top)', show: true },
        { code: '15', value: 'BV', description: 'Standard Top Offset Pivot (M19 Int/No Bottom)', show: true },
      ]
    },
    {
      name: "STD_DR Locking", publishedName: 'Locking', show: true, value: '', type: "list", options: [
        { code: '00', value: 'MORT', description: 'None', show: true },
        { code: '01', value: 'MORT', description: 'MS 1850 Deadbolt', show: true },
        { code: '04', value: 'MORT', description: 'MS 1853 Short Throw Deadbolt', show: true },
        { code: '05', value: 'MORT', description: 'MS 1850 Hookbolt', show: true },
        { code: '06', value: 'MORT', description: '4510 Latch Lock', show: true },
        { code: '02', value: 'MORT', description: 'MS 1850 Deadbolt w/ 2 Point Lock', show: true },
        { code: '03', value: 'MORT', description: 'MS 1850 Deadbolt w/ 3 Point Lock', show: true },
        { code: '03S', value: 'MORT', description: 'MS 1850 Deadbolt w/ 3 Point Lock (Shuttered) ', show: true },
        { code: '09', value: 'MORT', description: 'MS + 1890 Latch Lock', show: true },
        { code: '14', value: 'MORT', description: 'Controller', show: true },
        { code: '29', value: 'MORT', description: 'Controller FE', show: true },
        { code: '01M', value: 'MORT', description: '2 MS Locks (MS 1850 Default)', show: true },
        { code: '06B', value: 'MORT', description: '4510 Latch Lock w/ MS 1850 Below', show: true },
        { code: '06T', value: 'MORT', description: '4510 Latch Lock w/ MS 1850 Above', show: true },
        { code: '34', value: 'EXIT', description: 'Standard 1686 CVR Panic', show: true },
        { code: '20', value: 'EXIT', description: 'Falcon 1690 CVR Panic', show: true },
        { code: '15', value: 'EXIT', description: 'Falcon 1990 CVR Panic', show: true },
        { code: '33', value: 'EXIT', description: 'A/R 8600 CVR Panic', show: true },
        { code: '12', value: 'PNLN', description: 'Paneline', show: true },
        { code: '24', value: 'PNLN', description: 'Dummy Paneline', show: true },
        { code: '39', value: 'EXIT', description: 'Standard 1786 Rim Panic (w/removable Mull. on Pairs)', show: true },
        { code: '21', value: 'EXIT', description: 'Falcon 1790 Rim Panic(w/removable Mull. on Pairs)', show: true },
        { code: '16', value: 'EXIT', description: 'Falcon 2090 Rim Panic (w/removable Mull. on Pairs)', show: true },
        { code: '31', value: 'EXIT', description: 'Adams Rite 8400 Rim Panic', show: true },
      ]
    },
    {
      name: "All Push/Pull Finishs", publishedName: 'Push/Pull Finish', show: true, value: '', type: "list", options: [
        { code: '[COL:K:14 (14)]', value: '#B6B6', description: '14 (Clear Class I)', show: true },
        { code: '[COL:K:29 (29)]', value: '#000000', description: '29 (Black)', show: true },
        { code: '[COL:K:40 (40)]', value: '#180800', description: '40 (Dark Bronze)', show: true },  //we need to add some more
      ]
    },
    {
      name: "Hardware Finish modified by bill", publishedName: 'Hardware Finish', show: true, value: '', type: "list", options: [
        { code: '[COL:K:17 (17)]', value: '#B6B6', description: '17 (Clear Class II)', show: true },
        { code: '[COL:K:29 (29)]', value: '#000000', description: '29 (Black)', show: true },
        { code: '[COL:K:40 (40)]', value: '#180800', description: '40 (Dark Bronze)', show: true },
      ]
    },
    {
      name: "Cross Rails", publishedName: 'Cross Rails', show: true, value: '', type: "list", options: [
        { code: '00', value: '', description: 'No Cross Rails', show: true },
        { code: '1 Cross Rail', value: '1X', description: '1 Cross Rail', show: true },
        { code: '2 Cross Rails', value: '2X', description: '2 Cross Rails', show: true },
      ]
    },
    {
      name: "Hardware Finish modified by Amy", publishedName: 'Hardware Finish', show: true, value: '', type: "list", options: [
        { code: '[COL:K:17 (17)]', value: '#B6B6', description: '17 (Clear Class II)', show: true },
        { code: '[COL:K:29 (29)]', value: '#000000', description: '29 (Black)', show: true },
        { code: '[COL:K:40 (40)]', value: '80800', description: '40 (Dark Bronze)', show: true },
      ]
    },
    {
      name: "Hardware Finish", publishedName: 'Hardware Finish', show: true, value: '', type: "list", options: [
        { code: '[COL:K:17 (17)]', value: '#B6B6', description: '17 (Clear Class II)', show: true },
        { code: '[COL:K:29 (29)]', value: '#000000', description: '29 (Black)', show: true },
        { code: '[COL:K:40 (40)]', value: '80800', description: '40 (Dark Bronze)', show: true },
      ]
    },
    {
      name: "Exterior Finish-Modified by Amy", publishedName: 'Exterior Finish', show: true, value: '', type: "list", options: [
        { code: '[COL:K:14 (14)]', value: '#B6B6', description: '14 (Clear Class I)', show: true },
        { code: '[COL:K:17 (17)]', value: '#B6B6B6', description: '17 (Clear Class II)', show: true },
        { code: '[COL:K:18 (18)]', value: '#B6B6B6', description: '18 (Champagne)', show: true },
        //{ code: '[COL:K:26 (26)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:28 (28)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:29 (29)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:40 (40)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC100027 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109846 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109880 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109861 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109852 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109850 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109909 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109860 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109848 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109881 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109862 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:UC109851 (22)]', value: '2X', description: '2 Cross Rails', show: true },

        //{ code: '[COL:K:ORSM 31006 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42939 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42963 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 71885 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 21030 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42955 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 21130 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 81249 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 61102 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42942 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42945 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 71880 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 71870 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 61105 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 31466 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 31470 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 21026 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 71877 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 42958 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:ORSL 50397 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G035 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G026 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G039 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G019 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G024 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G013 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G036 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G017 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G048 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G021 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G046 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G025 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G027 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G016 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G018 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G023 (22)]', value: '2X', description: '2 Cross Rails', show: true },
        //{ code: '[COL:K:789G022 (22)]', value: '2X', description: '2 Cross Rails', show: true },
      ]
    }
  ];
  //#endregion

  getAttributes() {
    return this.attributeList;
    //
  }
  //#region   Api endPoints
  public getAll(): Observable<Array<IBuildPakAttribute>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.GET_ALL_V6ATTRIBUTES}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((attributes) => { this.attributeList = attributes })
      );
  }
  //#endregion

  getAttributeByName(name) {
    let attr = this.attributeList.find(x => x.name === name);
    if (!attr) {
      console.log('problem attribute not found', name);
      attr = {};
    }
    return attr;
  }

  public set attributes(attributes: Array<IProductAttribute>) {
    const v6Attributes: IBuildPakAttribute[] = [];
    if (attributes) {
      attributes.forEach((item, index) => {
        const v6attribute = ({
          id: item.attributeId, v6ReferenceCode: item.v6OptionCode, isDirty: false,
          name: item.attributeName, publishedName: item.publishedName, show: true,
          type: "", value: "", options: []
        }) as IBuildPakAttribute;

        if (item.attributeValues) {
          item.attributeValues.forEach((itemValue, index) => {
            const v6AttributeOption = ({
              code: itemValue.v6Code, description: itemValue.attributeValueDescription, v6ReferenceCode: itemValue.valuesFromV6,
              show: true, value: itemValue.attributeValueName, id: itemValue.attributeId, name: itemValue.attributeValueName
            }) as IAttributeOption;

            v6attribute.options.push(v6AttributeOption)
          });
        }
        v6Attributes.push(v6attribute);
      });
    }
    this.attributeList = v6Attributes;
  }
  public toIBuildPakAttributes(attributes: Array<IProductAttribute>): IBuildPakAttribute[] {

    const v6Attributes: IBuildPakAttribute[] = [];
    if (attributes) {
      attributes.forEach((item, index) => {
        const v6attribute = ({
          id: item.attributeId, v6ReferenceCode: item.v6OptionCode, isDirty: false,
          name: item.attributeName, publishedName: item.publishedName, show: true,
          type: item.attributeValueTypeName, value: "", options: []
        }) as IBuildPakAttribute;

        if (item.attributeValues) {
          item.attributeValues.forEach((itemValue, index) => {
            const v6AttributeOption = ({
              code: itemValue.v6Code, description: itemValue.attributeValueDescription,
              v6ReferenceCode: itemValue.valuesFromV6, show: true, value: itemValue.attributeValueName,
              id: itemValue.attributeId, name: itemValue.attributeValueName
            }) as IAttributeOption;

            v6attribute.options.push(v6AttributeOption)
          });
        }
        v6Attributes.push(v6attribute);
      });
    }
    return cloneDeep(v6Attributes);
  }

  attributeFilterChangeHandler(value: string) {
    return this.attributeList.filter((s: IAttributeOption) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
}
